import { render, staticRenderFns } from "./SystemBaseData.vue?vue&type=template&id=e70736f8&scoped=true&"
import script from "./SystemBaseData.vue?vue&type=script&lang=js&"
export * from "./SystemBaseData.vue?vue&type=script&lang=js&"
import style0 from "./SystemBaseData.vue?vue&type=style&index=0&id=e70736f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70736f8",
  null
  
)

export default component.exports